export default __webpack_public_path__ + "static/project-venturious-9c65a08090a1c68c0e325c9b019aebd9.png";